import { endpoint } from '../decorators/endpoint.decorator';
import { mappable } from '../decorators/mappable.decorator';
import { BaseViewModel } from './base-view-model';
import { CorrespondenceDocumentViewModel } from './correspondence-document-view-model';
import { DocumentFileViewModel } from './document-file-view-model';
import { ReviewDocumentViewModel } from './review-document-view-model';

@endpoint('Document')
export class DocumentViewModel extends BaseViewModel {
  public Filename = '';
  public ContentType = '';
  public Size = 0;
  public Url = '';

  @mappable('DocumentFileViewModel')
  public DocumentFile: DocumentFileViewModel = null;

  @mappable('CorrespondenceDocumentViewModel')
  public CorrespondenceDocument: CorrespondenceDocumentViewModel = null;

  @mappable('ReviewDocumentViewModel')
  public ReviewDocument: ReviewDocumentViewModel = null;

  public UUID: string = null;
}
